import {createTheme} from "@material-ui/core/styles";

/*
 * Tema único do front (o App.jsx só aplica). Cor de marca usada em componente
 * sai daqui via theme.palette.*, nunca como hex solto no makeStyles.
 */
const theme = createTheme({
    typography: {
        useNextVariants: true
    },
    palette: {
        primary: {
            main: '#20356C'
        },
        secondary: {
            main: '#D2D7E2',
            dark: 'rgba(0, 0, 0, 0.54)'
        },
        tertiary: {
            light: '#53b0f9',
            main: '#1672bb',
            dark: '#074b81'
        },
        quaternary: {
            light: '#79CED6',
            main: '#50B2BB',
            dark: '#30959E'
        },
        quinary: {
            light: '#a7c957',
            main: '#6d9021',
            dark: '#3f6612'
        },
        senary: {
            light: '#ffda79',
            main: '#ffc400',
            dark: '#b28900'
        },
        background: {
            default: '#ecedf1'
        },
        /*
         * Identidade visual da Unaerp além do primary: tons do degradê azul,
         * o amarelo da marca e os textos que ficam legíveis sobre o azul
         * (fundo em curva e painel de boas-vindas da identificação).
         */
        marca: {
            azulEscuro: '#16254b',
            azulClaro: '#27407f',
            amarelo: '#f4ce30',
            textoSobreAzul: '#e3e8f6',
            textoSecundarioSobreAzul: '#c3cfeb'
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 800,
            md: 960,
            lg: 1280,
            xl: 1920
        },
    },
    overrides: {
        MuiSelect: {
            /*
             * Valor escolhido: uma linha só, com "..." (o MUI já aplica nowrap +
             * ellipsis). Com a largura padrão (100%) o div do valor entra no
             * cálculo de largura mínima com o texto inteiro e estica o campo, o
             * cartão e a tela; com base 0 + flexGrow ele ocupa o mesmo espaço
             * sem empurrar nada, e o ellipsis passa a funcionar.
             */
            select: {
                minWidth: 0,
                width: 0,
                flexGrow: 1
            }
        },
        MuiTablePagination: {
            /*
             * Seletor de linhas por página da paginação das tabelas: volta à largura
             * do próprio conteúdo (o ajuste do MuiSelect acima o espremia em "5▾").
             */
            select: {
                width: 'auto',
                minWidth: 'auto',
                flexGrow: 0
            },
            // Espaço entre o seletor e o texto "1 até 5 de N registro(s)" (a margem do seletor o DataTable zera).
            caption: {
                marginLeft: 16
            }
        },
        MuiMenuItem: {
            /* Opções da lista: texto inteiro, quebrando linha em vez de cortar. */
            root: {
                whiteSpace: 'normal',
                wordBreak: 'break-word'
            }
        }
    }
});

export default theme;
